// @flow
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { SearchFacets } from 'Components/widgets/criteria/criteria-facets/search-facets/SearchFacets.jsx';
import { activeFacetsSelector, facetsSelector } from 'Store/faceting/faceting.selector';
import { clearFacets, toggleFacet } from 'Store/faceting/facetingSearch.action';
import {
  FILTERABLE_FACETS_TEMPLATE_CONFIG,
  FILTERABLE_FACETS_TRACKING_CONFIG,
} from 'Utils/faceting/constants';

export const CriteriaFacets = () => {
  const dispatch = useDispatch();
  const activeFacets = useSelector(activeFacetsSelector);
  const facets: Array<SearchFacetCategory> = useSelector(facetsSelector);

  return (
    <SearchFacets
      facets={facets}
      activeFacets={activeFacets}
      toggleFacet={({ categoryId, isSelected, value }) => {
        dispatch(
          toggleFacet({
            categoryId,
            isSelected,
            value,
          }),
        );
      }}
      clearFacets={categoryId => {
        dispatch(clearFacets(categoryId));
      }}
      facetLabels
      facetTemplateConfig={FILTERABLE_FACETS_TEMPLATE_CONFIG}
      facetTrackingConfig={FILTERABLE_FACETS_TRACKING_CONFIG}
    />
  );
};
